import { fetchAuthSession } from 'aws-amplify/auth';

function root_url() {
  if (window.location.host.includes('localhost')) {
    return 'https://uatapi.developerbadges.com'
  }
  return 'https://api.developerbadges.com'
}

export function get_badges(email) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching GET badges')
      fetch(root_url() + "/badges/email/" + email, { headers })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function get_email() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      resolve(session.tokens.idToken.payload.email.toLowerCase())
    })
  })
}

export function get_badge_administrators() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('Fetching GET badge administrators')
      fetch(root_url() + "/badges/badge_administrators", { headers })
        .then(response => {
          if (response.status != 200) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function post_badge(email, badge_id) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('POST badge')
      fetch(root_url() + "/badges/email/" + email + "/badge_id/" + badge_id, {
        method: 'POST',
        headers: headers,
      })
        .then(response => {
          if (response.status != 200 & response.status != 400) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function post_user() {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('POST user')
      fetch(root_url() + "/user", {
        method: 'POST',
        headers: headers,
      })
    })
  })
}

export function post_badge_administrator(email) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('POST badge administrator')
      fetch(root_url() + "/badges/badge_administrators/" + email, {
        method: 'POST',
        headers: headers,
      })
        .then(response => {
          if (response.status != 200 & response.status != 400) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}

export function delete_badge_administrator(email) {
  return new Promise((resolve) => {
    fetchAuthSession().then(session => {
      if (!session.tokens) {
        console.debug('Missing session tokens')
        resolve(null)
        return
      }
      let token = session.tokens.idToken
      const headers = {
        "Authorization": "Bearer " + token
      }
      console.debug('DELETE badge administrator')
      fetch(root_url() + "/badges/badge_administrators/" + email, {
        method: 'DELETE',
        headers: headers,
      })
        .then(response => {
          if (response.status != 200 & response.status != 400) {
            return null
          }
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
    })
  })
}
